import React, { useEffect, useState } from "react";
import { getOnlineRegistration } from "../Service/Api"; 
import { Link } from "react-router-dom";

const OnlineRegistration = () => {
  const [data, setData] = useState([]); 
  useEffect(() => {
   const fetchData = async () => {
     try {
       const data = await getOnlineRegistration();
       console.log(data)
       setData(data);
     } catch (error) {
       console.error("Error fetching online registration data:", error);
     }  
   };
   fetchData();
 }, []);

  return (
    <>
      <div className="online-reg">
        <ul style={{display:data.length>0?`block`:'none'}}> 
          <li className="group">
           <Link to={data[0]?.url} target="_blank" className="parantlogo ">  {data[0]?.title}  </Link>
           {data[0]?.attachments && data[0]?.attachments.length > 0 && ( <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[0]}`} target="_blank" className=""> <i className="bi bi-paperclip"></i></Link>)} 
          </li>  
        </ul>
      </div>
    </>
  );
};

export default OnlineRegistration;
